























import {EstimateState} from '@/model/api';
import {OfflineManager} from '@/model/offline/OfflineManager';
import { Modal } from 'bootstrap';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class SyncDialog extends Vue {
    @Prop({type: Object, required: true})
    public readonly offlineManager: OfflineManager;

    @Prop({type: Object, required: true})
    public readonly lastKnownEstimateState: EstimateState;

    private modal: Modal;

    public show(): void {
        this.modal.show();
    }

    protected mounted(): void {
        this.modal = new Modal(this.$refs.modal as HTMLElement);
    }

    protected sync(): void {
        this.offlineManager.syncWithServer(this.lastKnownEstimateState)
            .then(estimate => {
                this.$emit('sync', estimate);
                this.modal.hide();
            });
    }

    protected clear(): void {
        this.offlineManager.clear();
        this.modal.hide();
    }
}
